export class AzureNamespaceDisplay {
  Id: number;
  AzureNamespace: string;
  AzureAccount: string;
  AzureAccountId: number;
  RelatedEndpointsCount: number;
  LocationId: number;
  Location: string;
  LocationValue: string;
  ResourceGroup: string;
  KeyName: string;
  KeyValue: string;
  Status: boolean;
  SubscriptionId: string;
  Active: boolean;

  constructor() { }
}

export class AzureNamespace {
  Id: number;
  Namespace: string;
  AzureAccountIdFk: number;
  LocationIdFk: number;
  ResourceGroup: string;
  KeyName: string;
  KeyValue: string;
  Status: boolean;
  Active: boolean;

  constructor() { }
}

//ASSOCIATED WITH METHOD azure-operations.service.ts::checkNamespaceAvailability
export class NamespaceAvailableOnTheAzureResponse {
  nameAvailable: boolean;
  reason: string; //E.g NameInUse, InvalidName
  message: string;
}

//ASSOCIATED WITH METHOD azure-operations.service.ts::getKeysForANamespace
export class KeysForANamespace {
  primaryConnectionString: string;
  secondaryConnectionString: string;
  primaryKey: string;
  secondaryKey: string;
  keyName: string;

  constructor() { }
}

export class UpdateKeysRequest {
  id: number;
  keyName: string;
  keyValue: string;

  constructor() { }
}

export class UpdateActiveStatusRequest {
  id: number;
  active: boolean;

  constructor() { }
}
